@import "tailwindcss";

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  overflow: hidden;
  font-family: system-ui, -apple-system, sans-serif;
  background: linear-gradient(135deg, #1a5c2a 0%, #2d8a4e 40%, #1a5c2a 100%);
  min-height: 100dvh;
}
